import { Component, OnInit } from '@angular/core';
import { InmueblesService } from '../../services/inmuebles.service';
import { Globals } from '../../../globals';
import { Router } from '@angular/router';

@Component({
  selector: 'app-parques-industriales',
  templateUrl: './parques-industriales.component.html',
  styleUrls: ['./parques-industriales.component.css']
})
export class ParquesIndustrialesComponent implements OnInit {
  public almacenes = [];
  public cargando = true;
  portada: string = '';
  constructor(
    private _inmuebles: InmueblesService,
    private globals: Globals,
    private router: Router) {
      this._inmuebles.scrollTo(0);
    }

  ngOnInit() {
    this._inmuebles.getAllPortadas('Parques Industriales')
    .subscribe(portada => {this.portada = portada});
    this.getInmuebles();
  }

  getInmuebles() {
    this.cargando = true;
    this._inmuebles.getAllInmuebles('parque').subscribe((almacenes: any) => {
      almacenes.forEach(almacen => {
        almacen.caracteristicas = JSON.parse(almacen.caracteristicas);
        almacen.archivos.forEach(archivo => {
          archivo.src = `${this.globals.apiUrl}/UploadedFiles/getUploadedFiles?uuid=${archivo.uuid}&tipo=parque&id=${almacen.id}&random=${Math.floor(Math.random()*1000)}`
        });
        almacen.imagenPrincipal = almacen.archivos.find(a => a.esPrincipal);
      });
      this.almacenes = almacenes;
      this.cargando = false;
    }, err => this._inmuebles.showToastr('error', err));
  }

  irDetalle(almacen) {
    this.router.navigate(['/detalle','parque',almacen.nombre]);
  }
}
